module.exports = __webpack_public_path__ + "img/baaa6bb271618b20138ead802c9dbb1c.png";